<div class="multiple-actions-dialog">
  <!-- Header -->
  @if (data.title || data.titleTraductionKey) {
  <div class="dialog-header">
    <h2 mat-dialog-title>
      @if (data.titleTraductionKey) {
      <span>{{ data.titleTraductionKey | translate }}</span>
      } @else {
      {{ data.title }}
      }
    </h2>
    @if (data.subtitle || data.subtitleTraductionKey) {
    <p class="dialog-subtitle" style="margin-top: -15px;">
      @if (data.subtitleTraductionKey) {
      <span>{{ data.subtitleTraductionKey | translate
        }}</span>
      } @else {
      {{ data.subtitle }}
      }
    </p>
    }
    @if (data.messages?.length) {
    <div class="dialog-header">
      @for (message of data.messages; track $index; let last = $last) {
      <mat-divider></mat-divider>
      <div class="dialog-subtitle">
        @if (message.title || message.titleTraductionKey) {
        <div [ngClass]="message.cssClassTitle">
          @if (message.titleTraductionKey) {
          <span>{{ message.titleTraductionKey | translate }}</span>
          } @else {
          {{ message.title }}
          }
        </div>
        }
        @if (message.subTitles?.length) {
        <ul>
          @for (subTitle of message.subTitles; track $index) {
          <li>
            @if (subTitle.titleTraductionKey) {
            <span>{{ subTitle.titleTraductionKey | translate }}</span>
            } @else {
            {{ subTitle.title }}
            }
            @if (subTitle.subtitle || subTitle.subtitleTraductionKey) {
            <div>
              @if (subTitle.subtitleTraductionKey) {
              <span>{{ subTitle.subtitleTraductionKey | translate }}</span>
              } @else {
              {{ subTitle.subtitle }}
              }
            </div>
            }
          </li>
          }
        </ul>
        }
      </div>
      }
    </div>
    }
  </div>
  }

  <!-- Content -->
  <mat-dialog-content>
    @if (hasActions) {
    <div class="actions-container">
      <div class="action-grid">
        @for (action of data.actions; track trackByActionId($index, action)) {
        <button mat-raised-button [class]="getActionButtonClass(action)" [disabled]="isActionDisabled(action)"
          (click)="clickAction(action)">
          <!-- Icon -->
          @if (action.icon) {
          <mat-icon class="action-icon">{{ action.icon }}</mat-icon>
          }
          <!-- Label -->
          <span class="action-label">
            @if (action.traductionKey;) {
            <span>{{ action.traductionKey | translate }}</span>
            }
          </span>
          <!-- Selection indicator -->
          @if (isActionSelected(action)) {
          <mat-icon class="selection-indicator">check</mat-icon>
          }
        </button>
        }
      </div>
    </div>
    }

    @if (!hasActions) {
    <div class="no-actions">
      <p>{{ 'noActionsAvailable' | translate }}</p>
    </div>
    }
  </mat-dialog-content>

  <!-- Actions -->
  <!-- <mat-dialog-actions align="end" class="dialog-actions">
  <button
    mat-button
    *ngIf="data.showCancelButton"
    (click)="onCancel()">
    {{ data.cancelButtonLabel | translate }}
  </button>

  <button
    mat-raised-button
    color="primary"
    [disabled]="isConfirmDisabled"
    (click)="onConfirm()">
    {{ data.confirmButtonLabel | translate }}
  </button>
</mat-dialog-actions> -->
</div>